import { useSuspenseQuery } from '@tanstack/react-query';

import { getArticleValidationHistoryOptions } from '@/module/Author/Article/Validation/model/ArticleValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface ArticleValidationHistoryProps {
  articleId: Id;
}

export function ArticleValidationHistory({ articleId }: ArticleValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getArticleValidationHistoryOptions(articleId));

  return <ValidationHistoryContent history={history} />;
}
